import { useT } from '../i18n/locale-context';
import { useOnline } from '../lib/online-status';

/**
 * One line across the top of the app shell while the browser is offline:
 * «Нет соединения с интернетом». It appears on the `offline` event and goes on
 * `online` — nothing to dismiss, nothing remembered.
 *
 * Measured 22.10 (Redmi, network cut): a lot opened from the catalogue rendered
 * as an empty page with not a word about the network, and the search said the
 * site was working. Pages now say it in their own empty states too; this line
 * is what explains everything ELSE on screen that stopped answering — a button
 * that does nothing, a list that stays as it was.
 *
 * `role="status"` (polite): announced once, never steals focus. Renders
 * nothing on the server and during hydration (`useOnline` answers "online"
 * there), so prerendered HTML is unchanged.
 */
export function OfflineBanner() {
  const t = useT();
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      className="shrink-0 bg-status-closing-bg px-4 py-1.5 text-center text-[12.5px] font-semibold text-status-closing-text"
    >
      {t('offline.banner')}
    </div>
  );
}
